export default __webpack_public_path__ + "static/media/room-2Bed-double-F3.9b47a1a2.jpg";